import React from 'react';

import Icon from '@atlaskit/icon/base-new';

type TrelloInboxIconProps = {
	label: string;
	size?: 'small' | 'medium';
};

/**
 * Monochrome Trello board icon matching the design system icon style
 * used by other items in the highlight actions menu (e.g. WorkItemIcon).
 *
 * Path data sourced from design-team-provided Trello-16px.svg,
 * translated from a 24x24 viewBox (offset 4,4) to 16x16.
 */
export const TrelloInboxIcon = (props: TrelloInboxIconProps) => (
	<Icon
		name="TrelloInboxIcon"
		dangerouslySetGlyph={`<path fill="currentcolor" fill-rule="evenodd" clip-rule="evenodd" d="M14.0979 0H1.90212C0.85171 0 0 0.85171 0 1.90212V14.0979C0 15.1483 0.85171 16 1.90212 16H14.0979C15.1483 16 16 15.1483 16 14.0979V1.90212C16 0.85171 15.1483 0 14.0979 0ZM6.8922 11.5241C6.8922 11.8734 6.6091 12.156 6.2603 12.156H3.58592C3.2366 12.156 2.954 11.8729 2.954 11.5241V3.58592C2.954 3.2366 3.23709 2.954 3.58592 2.954H6.2603C6.6096 2.954 6.8922 3.23709 6.8922 3.58592V11.5241ZM13.046 7.8798C13.046 8.2291 12.7629 8.5117 12.4141 8.5117H9.7397C9.3904 8.5117 9.1078 8.2286 9.1078 7.8798V3.58592C9.1078 3.2366 9.3909 2.954 9.7397 2.954H12.4141C12.7634 2.954 13.046 3.23709 13.046 3.58592V7.8798Z"/>`}
		{...props}
	/>
);
